<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Clave"
      label="Clave"
      type="text"
      v-model="formData.Clave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Código único del centro de costo"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="100"
      helpText="Nombre del centro de costo"
    />
    
    <FormField
      id="Numero"
      label="Número"
      type="text"
      v-model="formData.Numero"
      :maxlength="50"
      helpText="Número del centro de costo"
    />
    
    <FormField
      id="Clave2"
      label="Clave 2"
      type="text"
      v-model="formData.Clave2"
      :maxlength="50"
      helpText="Clave secundaria del centro de costo"
    />
    
    <FormField
      id="ClaveErp"
      label="Clave ERP"
      type="text"
      v-model="formData.ClaveErp"
      :maxlength="50"
      helpText="Clave del sistema ERP"
    />
    
    <FormField
      id="DimensionNum"
      label="Dimensión"
      type="number"
      v-model="formData.DimensionNum"
      helpText="Número de dimensión"
    />
    
    <FormField
      id="PadreClave"
      label="Clave Padre"
      type="text"
      v-model="formData.PadreClave"
      :maxlength="50"
      helpText="Clave del centro de costo padre"
    />
    
    <FormField
      id="EsActivo"
      label="Estado"
      type="checkbox"
      v-model="formData.EsActivo"
      checkboxLabel="Centro de costo activo"
      helpText="Indica si el centro de costo está activo en el sistema"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatCecoForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    ceco: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: 1,
        Nombre: '',
        Numero: '',
        Clave2: '',
        ClaveErp: '',
        DimensionNum: 0,
        PadreClave: '',
        EsActivo: true
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.ceco }
    };
  },
  watch: {
    ceco: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>